import sanctumService from './sanctumService';

const sanctum = new sanctumService();

export default sanctum;
